import Login from './Login';
import ModernLogin from './ModernLogin';
import Main from './Main';
import { getLoginToken } from './Utils';

function App() {
  var token = getLoginToken();
  if (token && token.data) {
    return <div className='Main'>
      <Main />
    </div>
  } else {
    // 随机选择登录页面样式
    const useModernLogin = Math.random() < 0.5;
    
    return (
      <div className='App'>
        {useModernLogin ? <ModernLogin /> : <Login />}
      </div>
    );
  }
}

export default App;
